// extracted by mini-css-extract-plugin
export default {"card":"styles_card__3qDwA","sub":"styles_sub__nuWq7","kcals":"styles_kcals__PRp0X","name":"styles_name__WziYP","makro":"styles_makro__RFzPz"};